import ActionsEngine from "../actions/engine";
import RulesEngine from "../rules/engine";

class Proposition {
  config;
  title;
  guid;
  initialized = false;

  rulesEngine;
  actionsEngine;

  logPrefix = "\x1b[30;43;1m[Proposition]";

  constructor(config) {
    this.config = config;
    this.title = config.title;
    this.guid = config.guid;
    this.initialize();
  }

  /**
   * Initalize the proposition
   * 
   * @returns {undefined}
   */
  initialize() {
    if (this.initialized) return;

    this.actionsEngine = this.createEngine(ActionsEngine, this.config.actions);
    this.rulesEngine = this.createEngine(RulesEngine, this.config.rules);

    this.initialized = true;
  }

  /**
   * Create an engine from a class and an array of component definitions.
   * 
   * @param {typeof ActionsEngine|typeof RulesEngine} engineClass
   * @param {Object[]} componentDefinitions 
   * @returns {ActionsEngine|RulesEngine}
   */
  createEngine(engineClass, componentDefinitions) {
    const engine = new engineClass();

    componentDefinitions.forEach((componentDefinition, index) => {
      // GUID is composed of the proposition GUID (which is likely the 
      // metaobject ID), the component type, and the index (in case there are
      // multiple components of the same type in a given proposition).
      const componentGUID = `${this.guid}-${componentDefinition.type}-${index}`;
      const component = engineClass.fromJSON(componentDefinition);
      component.guid = componentGUID;
      engine.add(component);
    });

    return engine;
  }

  /**
   * Handle a trigger event by evaluation this proposition's rules and executing
   * its actions if those rules are met.
   * 
   * @param {Event} e 
   * @param {String} eventName 
   * @returns {Promise}
   */
  async handleEvent(e, eventName){
    console.group(`${this.logPrefix}`, `${this.title}`);

    let meetsConditions = await this.rulesEngine.evaluate(e.detail);

    console.log(`${this.logPrefix}`, `Rules met?`, meetsConditions ? "✅" : "❌");
    console.log(`${this.logPrefix}`, `Rules Log`);
    console.table(this.rulesEngine.log);

    // Pass all rules? Run all actions
    let result = null;
    if(meetsConditions){
      result = await this.actionsEngine.execute(e.detail);
    } else {
      result = await this.actionsEngine.undo(e.detail);
    }

    console.log(`${this.logPrefix}`, `Actions Log`);
    console.table(this.actionsEngine.log);
    console.groupEnd();

    return result;
  }

  /**
   * Describe the proposition in the console.
   */
  async explain() {
    console.group(`${this.logPrefix}`, `${this.title}`);
    await this.rulesEngine.explain();
    await this.actionsEngine.explain();
    console.groupEnd();
  }
}

export default Proposition;